import type { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";

/** A key figure's value while it loads, fails or is there. */
export function KeyFigureValue({
  isLoading,
  error,
  children,
}: {
  isLoading: boolean;
  error: unknown;
  children: ReactNode;
}) {
  if (isLoading) return <Skeleton className="h-9 w-24" />;
  if (error) return "—";
  return children;
}
